export default __webpack_public_path__ + "static/media/navbar-my-account-orange.ad6fef8b.svg";